import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'
import { gpEcommerceEventFactory } from '@/vendor/gtm/events/gp/ecommerce'
import { executeWebCustomerConversionTag } from '@/vendor/web-customer-service-tool'

export function sendToWebCustomerTool(event: PurchaseEvent): void {
  const payload = convertToWebCustomerFormat(event)
  executeWebCustomerConversionTag(payload)
}

/**
 * Web接客ツールは（たまたま）、GTMに送信されるe-commerceデータ型を前提として調整されている
 */
const convertToWebCustomerFormat = gpEcommerceEventFactory.createFromEventBusPurchaseEvent
